export default {
      id: "non-alcoholic-usage",
      viewBox: "0 0 19 31",
      url: __webpack_public_path__ + "img/icons.svg#non-alcoholic",
      toString: function () {
        return this.url;
      }
    }